<div class="container-fluid complyon-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell mx-auto">
    <div class="mb-3">
      <h1 class="complyon-title mb-2 text-l">Integrations</h1>
      <p class="complyon-subtitle mb-0 text-s">Connected systems that feed live evidence into controls, obligations and reports - SARS, CIPC, CSD, identity, ERP and more.</p>
    </div>

    <div class="row g-3 mb-3">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
        <div class="complyon-card rounded-4 p-3 h-100">
          <div class="text-uppercase text-xs text-secondary fw-semibold">{{ card.label }}</div>
          <div class="text-l fw-bold mt-1">{{ card.value }}</div>
          <div class="text-xs text-secondary mt-3">{{ card.note }}</div>
        </div>
      </div>
    </div>

    <div class="complyon-panel rounded-4 overflow-hidden">
      <div class="d-flex align-items-start justify-content-between gap-3 px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
        <div>
          <div class="complyon-section-title text-s">Integrations</div>
          <div class="complyon-section-subtitle text-xs">Connected systems that feed live evidence into controls, obligations and reports. Open one to trace exactly what it feeds.</div>
        </div>
        <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2">
          <i class="bi bi-plus-lg"></i>
          <span>Add connector</span>
        </button>
      </div>

      <div class="px-3 px-md-4 py-3 py-md-4">
        <div class="row g-3">
          <div v-for="item in connectors" :key="item.title" class="col-12 col-xl-6">
            <div class="complyon-card rounded-4 p-3 h-100">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex align-items-start gap-3 min-w-0">
                  <div class="d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 bg-light text-secondary border border-light" style="width: 2rem; height: 2rem;">
                    <i class="bi bi-box-arrow-up-right"></i>
                  </div>
                  <div class="min-w-0">
                    <div class="fw-semibold text-s">{{ item.title }}</div>
                    <div class="text-xs text-secondary">{{ item.subtitle }}</div>
                  </div>
                </div>
                <span class="badge rounded-pill" :class="item.status_class">{{ item.status }}</span>
              </div>

              <div class="mt-3 text-xs">{{ item.description }}</div>

              <div class="mt-3">
                <div class="text-uppercase text-xs text-secondary fw-semibold mb-2">Feeds</div>
                <div class="d-flex flex-wrap gap-2">
                  <span v-for="feed in item.feeds" :key="`${item.title}-${feed}`" class="badge rounded-pill bg-light text-secondary border border-light">{{ feed }}</span>
                </div>
              </div>

              <div class="mt-3 pt-3 border-top">
                <button type="button" class="btn btn-link text-decoration-none p-0 d-inline-flex align-items-center gap-2 text-secondary">
                  <i class="bi bi-diagram-3"></i>
                  <span>{{ item.footer }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
